<div class="row">
  <div class="col-sm-1"></div>
  <div class="col-sm-10"></div>
  <div class="col-sm-1"></div>
</div>
<section style="overflow-x: hidden;">
  <img
    class="css-z1tvno"
    src="assets/img/walpaper.jpeg"
    alt="top-bg"
    style="
      display: block;
      position: absolute;
      width: 100%;
      height: 50vh;
      object-fit: cover;
      
      font-size: 14px;
    "
  />
</section>
<section
  style="
    padding-top: 400px;
    padding-bottom: 64px;
    position: relative;
    display: block;
    overflow-x: hidden;
  "
>
  <div
    style="
      width: 100%;
      padding-left: 15px;
      padding-right: 15px;
      margin-left: auto;
      margin-right: auto;
    "
  ></div>
</section>
<section style="display: block; overflow-x: hidden; overflow-y: hidden;">
  <div class="row">
    <h1
      class="text-why-sukanda"
      style="
        font-size: 32px;
        line-height: 1.41;
        color: #0a0a0a;
        font-weight: 800;
        text-align: center;
        
      "
    >
      How To Use Sukanda Onelink ?
    </h1>
  </div>
  <!-- <div
    class="row"
    style="
      margin-right: auto;
      margin-left: auto;
      padding-left: 36px;
      padding-right: 36px;
    "
  >
    <div class="col-sm-12">
      <div
        style="
          font-size: 32px;
          line-height: 1.41;
          color: #0a0a0a;
          font-weight: 800;
          
          text-align: center;
        "
      >
        <p>Cara Mengakses</p>
      </div>
    </div>
    <div class="col-sm-8">
      <img
        class="logo-img-x forminlinemargin"
        src="assets/img/website sol.png"
        style="width: 100%; height: 100%; margin-left: 25%;"
      />
    </div>
  </div>
  <br />
  <br />
  <br />
  <br />
  <br />
  <br /> -->
  <!-- <div
    class="row"
    style="
      margin-right: auto;
      margin-left: 20%;
      padding-left: 60px;
      padding-right: 60px;
    "
  >
    <div class="col-sm-6">
      <div class="col-sm-6">
        <img
          class="logo-img-x forminlinemargin"
          src="assets/img/Picture2.png"
          style="max-width: 100%; height: auto;"
        />
      </div>
    </div>
    <div class="col-sm-6">
      <img
        class="logo-img-x forminlinemargin"
        src="assets/img/Picture1.png"
        style="max-width: 100%; height: auto;"
      />
    </div>
    <div class="col-sm-6">
      <div
        style="
          font-size: 32px;
          color: #0a0a0a;
          font-weight: 800;
          
        "
      ></div>
      <br />
      <div class="col-sm-6" style="margin-top: -19px;">
        <img
          class="logo-img-x forminlinemargin"
          src="assets/img/Capture2.png"
          style="max-width: 100%; height: auto;"
        />
      </div>
    </div>
    <div class="col-sm-6">
      <img
        class="logo-img-x forminlinemargin"
        src="assets/img/Capture1.png"
        style="max-width: 100%; height: auto;"
      />
    </div>
  </div>
  <br />
  <br />
  <br />
  <br />
  <br />
  <br /> -->
  <!-- <div
    class="row"
    style="
      margin-right: auto;
      margin-left: auto;
      padding-left: 36px;
      padding-right: 36px;
    "
  >
    <div class="col-sm-12">
      <div
        style="
          font-size: 32px;
          line-height: 1.41;
          color: #0a0a0a;
          font-weight: 800;
          
          text-align: center;
        "
      >
        <p>Login</p>
      </div>
    </div>
    <div class="col-sm-8">
      <img
        class="logo-img-x forminlinemargin"
        src="assets/img/login sol.png"
        style="width: 100%; height: 100%; margin-left: 25%;"
      />
    </div>
  </div>
  <br />
  <br />
  <br />
  <br />
  <br />
  <br /> -->
  <!-- <div
    class="row"
    style="
      margin-right: auto;
      margin-left: auto;
      padding-left: 36px;
      padding-right: 36px;
    "
  >
    <div class="col-sm-12">
      <div
        style="
          font-size: 32px;
          line-height: 1.41;
          color: #0a0a0a;
          font-weight: 800;
          
          text-align: center;
        "
      >
        <p>Membuat Pesanan</p>
      </div>
    </div>
    <div
      style="
        font-size: 24px;
        line-height: 1.41;
        color: #0a0a0a;
        font-weight: 800;
        
        text-align: center;
      "
    >
      <p>Pilih salah satu katalog</p>
    </div>
    <div class="col-sm-8">
      <img
        class="logo-img-x forminlinemargin"
        src="assets/img/catalogue sol.png"
        style="width: 100%; height: 100%; margin-left: 25%;"
      />
    </div>
    <div
      style="
        font-size: 24px;
        line-height: 1.41;
        color: #0a0a0a;
        font-weight: 800;
        
        text-align: center;
      "
    >
      <p>Melakukan pencarian barang</p>
      <p>tambahkan kuantiti</p>
      <p>dan klik tombol cart</p>
    </div>
    <div class="col-sm-8">
      <img
        class="logo-img-x forminlinemargin"
        src="assets/img/pencarian sol.png"
        style="width: 100%; height: 100%; margin-left: 25%;"
      />
    </div>
    <div
      style="
        font-size: 24px;
        line-height: 1.41;
        color: #0a0a0a;
        font-weight: 800;
        
        text-align: center;
      "
    >
      <p>Tambahkan keterangan di kolom Delivery Notes</p>

      <p>ataupun Product Request untuk spesial request ke sales admin</p>

      <p>dan klik tombol submit</p>
    </div>
    <div class="col-sm-8">
      <img
        class="logo-img-x forminlinemargin"
        src="assets/img/cart sol.png"
        style="width: 100%; height: 100%; margin-left: 25%;"
      />
    </div>
    <div
      style="
        font-size: 32px;
        line-height: 1.41;
        color: #0a0a0a;
        font-weight: 800;
        
        text-align: center;
      "
    >
      <p>Synchronize Data</p>
    </div>
    <div class="col-sm-8">
      <img
        class="logo-img-x forminlinemargin"
        src="assets/img/sync.jpeg"
        style="width: 40%; height: 100%; margin-left: 50%;"
      />
    </div>
  </div>
  <br />
  <br /> -->
  <!-- <div
    class="row"
    style="
      margin-right: auto;
      margin-left: auto;
      padding-left: 36px;
      padding-right: 36px;
    "
  >
    <div
      style="
        font-size: 32px;
        line-height: 1.41;
        color: #0a0a0a;
        font-weight: 800;
        
        text-align: center;
      "
    >
      <p>Cek Status Orderan</p>
    </div>
    <div class="col-sm-8">
      <img
        class="logo-img-x forminlinemargin"
        src="assets/img/cek status order sol.png"
        style="width: 100%; height: 100%; margin-left: 25%;"
      />
    </div>
  </div> -->
</section>
<div class="container-fluid">
  <div class="row">
    <div class="col-sm-3 col-3" style="background-color: whitesmoke;">
      <a class="nav-link">
        <h5>How To use</h5>
      </a>
      <div
        class="nav flex-column nav-pills"
        id="v-pills-tab"
        role="tablist"
        aria-orientation="vertical"
      >
        <a
          class="nav-link active"
          id="v-work-hour-tab"
          data-toggle="pill"
          href="#v-work-hour"
          role="tab"
          aria-controls="v-work-hour"
          aria-selected="true"
          >Cara Mengakses</a
        >
        <a
          class="nav-link"
          id="v-pills-download-tab"
          data-toggle="pill"
          href="#v-pills-download"
          role="tab"
          aria-controls="v-pills-download"
          aria-selected="false"
          >Login</a
        >
        <a
          class="nav-link"
          id="v-pills-forget-pass-tab"
          data-toggle="pill"
          href="#v-pills-forget-pass"
          role="tab"
          aria-controls="v-pills-forget-pass"
          aria-selected="false"
          >Membuat Pesanan</a
        >
        <a
          class="nav-link"
          id="v-pills-change-pass-tab"
          data-toggle="pill"
          href="#v-pills-change-pass"
          role="tab"
          aria-controls="v-pills-change-pass"
          aria-selected="false"
          >Synchronize data</a
        >
        <a
          class="nav-link"
          id="v-pills-order-item-tab"
          data-toggle="pill"
          href="#v-pills-order-item"
          role="tab"
          aria-controls="v-pills-order-item"
          aria-selected="false"
          >Cek Status Orderan</a
        >
      </div>
    </div>
    <div class="col-sm-9 col-9"  style="background-color: ghostwhite;">
      <h1>Sukanda Onelink</h1>
      <br />
      <div class="tab-content" id="v-pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="v-work-hour"
          role="tabpanel"
          aria-labelledby="v-work-hour-tab"
        >
          <h4>Akses</h4>
          <p>
            Ayo Kunjungin Website Sukanda Onelink atau Bisa Juga dengan
            menginstall Aplikasi Sukanda Onelink dari Handphone Kamu
          </p>
          <table class="table">
            <tbody>
              <tr>
                <td>Websites Sukanda Onelink</td>
                <td>https://www.sukandaonelink.com</td>
              </tr>
              <tr>
                <img
                class="logo-img-x forminlinemargin"
                src="assets/img/website sol.png"
                style="width: 100%; height: 100%; margin-left: 25%;"
              />
              </tr>
              <tr>
                <td>
                  Buruan Install Aplikasi Sukanda Onelink Pada Handphone Kamu
                  Ya di:
                </td>
              </tr>
              <tr>
                <td>Playstore</td>
                <td>
                  https://play.google.com/store/apps/details?id=com.sukanda.onelink
                </td>
              </tr>
              <tr>
                <img
          class="logo-img-x forminlinemargin"
          src="assets/img/Picture2.png"
          style="max-width: 100%; height: auto;margin-left: 60%;"
        />
              </tr>
              <tr>
              <img
              class="logo-img-x forminlinemargin"
              src="assets/img/Capture2.png"
              style="max-width: 100%; height: auto;margin-left: 60%;"
            />
                  </tr>
              <tr>
                <td>Appstore</td>
                <td>
                  https://apps.apple.com/id/app/sukanda-onelink/id1544732426?l=id
                </td>
              </tr>
              <tr>
                <img
        class="logo-img-x forminlinemargin"
        src="assets/img/Picture1.png"
        style="max-width: 100%; height: auto;margin-left: 60%;"
      />
              </tr>
              <tr>
                <img
                class="logo-img-x forminlinemargin"
                src="assets/img/Capture1.png"
                style="max-width: 100%; height: auto;margin-left: 60%;"
              />
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="tab-pane fade"
          id="v-pills-download"
          role="tabpanel"
          aria-labelledby="v-pills-download-tab"
        >
          <h4>Login atau Registrasi</h4>
          <p>
            Mendaftarkan akun ke sales kemudian setelah mendapatkan password
            login ke
            <a
              href="https://idp.pepperi.com/Account/Login?ReturnUrl=%2Fconnect%2Fauthorize%2Fcallback%3Fclient_id%3Dpepperi.webapp.www.sukandaonelink.com%26redirect_uri%3Dhttps%253A%252F%252Fwww.sukandaonelink.com%252Fcallback.html%26response_type%3Dcode%26scope%3Dopenid%2520profile%2520pepperi.webapp_api%2520pepperi.profile%2520pepperi.webapp_identity%2520pepperi.apint%26state%3D96853cac34694c198b349b260598baf4%26code_challenge%3D4dLrB1oaeKJ2grjpIm3JKUDDrcWVaug8v4NH_p9NgdY%26code_challenge_method%3DS256%26response_mode%3Dquery"
              >tautan ini</a
            >
            , atau register sendiri dengan menu regiter di form customer
          </p>
          <div class="col-sm-8">
            <img
        class="logo-img-x forminlinemargin"
        src="assets/img/login sol.png"
        style="width: 100%; height: 100%; margin-left: 25%;"
      />
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="v-pills-forget-pass"
          role="tabpanel"
          aria-labelledby="v-pills-forget-pass"
        >
          <h4>Membuat Pesanan</h4>
          <p>
            Dalam aplikasi Sukanda Onelink ini user diharapkan menyelesaikan
            order pada satu katalog sebelum membuat order baru pada katalog yang
            lain. Untuk menambahkan produk ke keranjang Anda dan membuat
            pesanan, berikut langkah-langkahnya:
          </p>
          <table class="table">
            <tbody>
              <tr>
                <td>1.</td>
                <td>Pilih salah satu katalog</td>
              </tr>
              <div class="col-sm-8">
                <img
                  class="logo-img-x forminlinemargin"
                  src="assets/img/catalogue sol.png"
                  style="width: 200%; height: 100%;"
                />
              </div>
              <tr>
                <td>2.</td>
                <td>Melakukan pencarian barang dan tambahkan kuantiti</td>
              </tr>
              <div class="col-sm-8">
                <img
                  class="logo-img-x forminlinemargin"
                  src="assets/img/pencarian sol.png"
                  style="width: 200%; height: 100%;"
                />
              </div>
              <tr>
                <td>3.</td>
                <td>Klik tombol <b>Cart</b> untuk melakukan transaksi</td>
              </tr>
              <tr>
                <td>4.</td>
                <td>
                  Tambahkan keterangan di kolom <b>Delivery Notes</b> ataupun
                  <b>Product Request</b> untuk spesial request ke sales admin
                </td>
              </tr>
              <tr>
                <td>5.</td>
                <td>Klik <b>Submit</b></td>
              </tr>
              <div class="col-sm-8">
                <img
                  class="logo-img-x forminlinemargin"
                  src="assets/img/cart sol.png"
                  style="width: 200%; height: 100%;"
                />
              </div>
            </tbody>
          </table>
        </div>
        <div
          class="tab-pane fade"
          id="v-pills-change-pass"
          role="tabpanel"
          aria-labelledby="v-pills-change-pass"
        >
          <h4>Synchronize Data</h4>
          <table class="table">
            <tbody>
              <tr>
                <td>
                  Setelah login lakukan sync jika waktu sync dan jam saat ini
                  tidak sama.
                </td>
              </tr>
              <tr>
                <img
                class="logo-img-x forminlinemargin"
                src="assets/img/sync.jpeg"
                style="width: 30%; height: 100%;"
                />
              </tr>
              <tr>
                <td>
                  User tidak perlu sync apabila handphone nya telah otomatis
                  sync dan waktunya sudah sesuai.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="tab-pane fade"
          id="v-pills-order-item"
          role="tabpanel"
          aria-labelledby="v-pills-order-item"
        >
          <h4>Cek Status Orderan</h4>
          <p>
            Untuk melihat sejauh mana proses pesanan yang telah dibuat, user
            bisa klik menu <b>My History</b> yang ada di pojok kanan atas.
            Berikut merupakan keterangan untuk status yang ada di riwayat
            pemesanan
          </p>
          <table class="table table-striped">
            <thead class="thead-dark">
              <tr>
                <th>Status</th>
                <th>Keterangan</th>
              </tr>
            </thead>
            <tbody>
              <div class="col-sm-8">
                <img
                  class="logo-img-x forminlinemargin"
                  src="assets/img/cek status order sol.png"
                  style="width: 200%; height: 100%;"
                />
              </div>
              <tr>
                <td>Draft</td>
                <td>Customer masih dalam proses untuk membuat pesanan</td>
              </tr>
              <tr>
                <td>Submitted</td>
                <td>
                  Pesanan telah disubmit / dikirim ke sales admin untuk
                  dilakukan proses verifikasi
                </td>
              </tr>
              <tr>
                <td>Response Required</td>
                <td>
                  Di dalam pesanan terdapat barang komoditi sehingga memerlukan
                  pengajuan harga ke sales admin
                </td>
              </tr>
              <tr>
                <td>Processed</td>
                <td>
                  Pesanan telah diverifikasi oleh sales admin dan sedang
                  diproses oleh penjual
                </td>
              </tr>
              <tr>
                <td>Canceled</td>
                <td>Pesanan dibatalkan</td>
              </tr>
              <tr>
                <td>Delivered</td>
                <td>Pesanan sedang diperjalanan untuk proses pengiriman</td>
              </tr>
              <tr>
                <td>Received</td>
                <td>Pesanan telah diterima oleh customer</td>
              </tr>
            </tbody>
          </table>
          <h4>Melacak Pesanan</h4>
          <p>
            Kustomer bisa melihat sampai di mana proses atas pesanan yang telah
            mereka buat
          </p>
          <p>Cara melihat proses pesanan:</p>
          <table class="table">
            <tbody>
              <tr>
                <td>1.</td>
                <td>Masuk ke menu <b>My History</b></td>
              </tr>
              <tr>
                <td>2.</td>
                <td>
                  Pilih salah satu riwayat pesanan dengan klik id nya, maka user
                  akan melihat detail pesanan
                </td>
              </tr>
              <tr>
                <td>3.</td>
                <td>
                  Klik lagi tombol tiga garis yang ada di kanan atas menu, dan
                  kemudian pilih <b>Deliveries Info</b>
                </td>
              </tr>
              <tr>
                <td>4.</td>
                <td>User akan melihat status pesanan yang telah dibuat</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
